'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.withSlideContext = exports.SlideContext = exports.Gallery = exports.ThemedGallery = undefined;

var _uiCarousel = require('@spp/ui-carousel');

var _themeProvider = require('@spp/theme-provider');

var _Gallery = require('./Gallery');

var _Gallery2 = _interopRequireDefault(_Gallery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThemedGallery = (0, _themeProvider.themer)('@spp/ui-gallery')(_Gallery2.default);

exports.ThemedGallery = ThemedGallery;
exports.Gallery = _Gallery2.default;
exports.SlideContext = _uiCarousel.SlideContext;
exports.withSlideContext = _uiCarousel.withSlideContext;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-gallery/lib/cjs/index.js
 ** module id = 297
 ** module chunks = 1
 **/